<div class="add-new-company-modal-container display-flex flex-column">
  <h2 mat-dialog-title class="modal-header">Add new vendor</h2>
  <mat-dialog-content>
    <form [formGroup]="form">
      <div class="display-flex flex-column grid-gap-16">
        <app-input
          [attrLabel]="'Vendor name:'"
          [contentCss]="'display-flex flex-column fill company-details-input body-small'"
          [formControl]="displayName"
          [attrPlaceholder]="'vendor name'"
          [labelRequired]="true"
        ></app-input>
        <app-input
          [attrLabel]="'Legal name:'"
          [contentCss]="'display-flex flex-column fill company-details-input body-small'"
          [formControl]="legalName"
          [attrPlaceholder]="'vendor legal name'"
          [labelRequired]="true"
        ></app-input>
      </div>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions class="justify-content-end">
    <button mat-stroked-button color="warn" (click)="cancel()">Cancel</button>
    <button mat-raised-button color="primary" (click)="save()">Save</button>
  </mat-dialog-actions>
</div>
